import { v1 } from './v1';

export const marathon = {
  v1,
};
